import { TimeReportDetailsView } from "./details";
import { TimeReportsView } from "./list";

export const views = {
  "time-reports": TimeReportsView,
  "time-reports.details": TimeReportDetailsView,
};
